import React from "react";
import { Link, useSearchParams } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  const [params] = useSearchParams();
  const bookingId = params.get("booking_id");
  return (
    <div className="max-w-xl mx-auto px-6 py-24 text-center">
      <XCircle className="w-16 h-16 text-red-500 mx-auto mb-6" />
      <h1 className="font-display font-extrabold text-4xl tracking-tighter mb-3">Payment cancelled</h1>
      <p className="text-[#0B1F3A]/70 mb-8">No worries — your reservation isn't confirmed. You can try again anytime.</p>
      <Link to="/fleet" className="btn-gold inline-flex" data-testid="cancel-return-fleet">Return to fleet</Link>
    </div>
  );
}
